import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getTaskStatusCreationError() {
      return getState().error;
    },
    isTaskStatusCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isTaskStatusCreationRequestPending() {
      return getState().request.isPending;
    },
    isTaskStatusCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
